import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Result } from "antd";
import React from "react";

import AntButtonGreen from "components/AntButtonGreen";
import AntModal from "components/AntModal";

import { IdleLogoutModalProps } from "./types";

export const IdleLogoutModal: React.FC<IdleLogoutModalProps> = ({
  visible,
  message,
  onClose,
}) => {
  return (
    <AntModal
      open={visible}
      onCancel={onClose}
      footer={[
        <AntButtonGreen
          key="ok"
          type="primary"
          onClick={onClose}
          style={{ display: "inline-flex" }}
        >
          OK
        </AntButtonGreen>,
      ]}
      closable={true}
    >
      <Result
        icon={<ExclamationCircleOutlined style={{ color: "#ffd667" }} />}
        title="Сеанс завершен"
        subTitle={message}
        style={{ padding: "24px 0" }}
      />
    </AntModal>
  );
};
